import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { SeatComfort } from '@websky/graphql';
import { CustomSeatComfort } from '@entities/seat-map';
import Money from '../../../../../Money/components/Money';
import { getCurrency } from '../../../../../cache';
import { useTheme } from '../../../../../theme';
const SeatInfo = ({ className, seats, name, description, price, parameters }) => {
    const { SeatInfo: css } = useTheme('Entities').SeatMap;
    const comfortToClassMap = {
        [SeatComfort.Standard]: css.seatInfo__figure_standard,
        [SeatComfort.Comfort]: css.seatInfo__figure_comfort,
        [SeatComfort.Preferred]: css.seatInfo__figure_preferred,
        [SeatComfort.Standart]: css.seatInfo__figure_standart,
        [CustomSeatComfort.Free]: css.seatInfo__figure_free,
        [CustomSeatComfort.Unavaliable]: css.seatInfo__figure_unavaliable
    };
    const { t } = useTranslation('SeatMap');
    const showBottom = price || (parameters === null || parameters === void 0 ? void 0 : parameters.length);
    return (React.createElement("div", { className: cn(css.seatInfo__wrapper, className) },
        React.createElement("div", { className: cn(css.seatInfo__top, { [css.seatInfo__top_column]: (seats === null || seats === void 0 ? void 0 : seats.length) > 1 }) },
            !!(seats === null || seats === void 0 ? void 0 : seats.length) && (React.createElement("div", { className: css.seatInfo__figures }, seats.map(seat => (React.createElement("div", { className: cn(css.seatInfo__figure, comfortToClassMap[seat.comfort], {
                    [css.seatInfo__figure_wide]: seats.length > 1
                }) }, seat.price && React.createElement(Money, { money: Object.assign(Object.assign({}, seat.price), { currency: getCurrency() }) })))))),
            React.createElement("div", { className: css.seatInfo__info },
                React.createElement("div", { className: css.seatInfo__title }, name),
                description && React.createElement("div", { className: css.seatInfo__description }, description))),
        showBottom && (React.createElement("div", { className: css.seatInfo__bottom },
            !!(parameters === null || parameters === void 0 ? void 0 : parameters.length) && (React.createElement("div", { className: css.seatInfo__parameters }, parameters.map(parameter => (React.createElement("div", { className: css.seatInfo__parameter },
                React.createElement("div", { className: css.seatInfo__parameterTitle }, `${t(parameter.title)}: `),
                React.createElement("div", { className: css.seatInfo__parameterValue }, t(parameter.value))))))),
            price && (React.createElement("div", { className: css.seatInfo__moneyWrapper },
                !!price.amount && t('from'),
                React.createElement(Money, { money: Object.assign(Object.assign({}, price), { currency: getCurrency() }) })))))));
};
export default SeatInfo;
